'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconIndent, iconIndentTag } from '@ni/nimble-components/dist/esm/icons/indent';
import { wrap } from '../../utilities/react-wrapper';

export type { IconIndent };
export { iconIndentTag };
export const NimbleIconIndent = wrap(IconIndent);